module.exports = __webpack_public_path__ + "img/ic_happix.9215aa1.svg";